import React from 'react';
import { Grid, Card, CardContent, Stack, Box, Typography, Avatar } from '@mui/material';
import FeedIcon from '@mui/icons-material/Feed';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { LoadingWrapper } from '../loading';

const ExpenseStatsCards = ({ stats, isLoading }) => {
  const statsCards = [
    {
      title: 'Total Expenses',
      value: stats.total_expenses || 0,
      icon: <FeedIcon />,
      color: 'primary.main',
    },
    {
      title: 'Total Amount',
      value: Number(stats.total_amount || 0).toLocaleString(undefined, { maximumFractionDigits: 2 }),
      icon: <AccountBalanceIcon />,
      color: 'success.main',
    },
    {
      title: 'Categories',
      value: stats.categories_count || 0,
      icon: <Typography variant="subtitle2">{stats.categories_count > 0 ? 'A' : '-'}</Typography>,
      color: 'warning.main',
    },
  ];

  return (
    <LoadingWrapper
      isLoading={isLoading}
      skeletonCount={3}
      showSectionTitle
      sectionTitle="Overview"
      containerSx={{ width: '100%' }}
    >
      <Grid container spacing={2}>
        {statsCards.map((stat, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card>
              <CardContent>
                <Stack direction="row" alignItems="center" justifyContent="space-between">
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      {stat.title}
                    </Typography>
                    <Typography variant="h4">{stat.value}</Typography>
                  </Box>
                  <Avatar sx={{ bgcolor: stat.color, color: 'primary.contrastText' }}>{stat.icon}</Avatar>
                </Stack>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
    </LoadingWrapper>
  );
};

export default ExpenseStatsCards;
